<template>
  <gh-table-page sort-by="Seq" ref="table" :args-query="args" module="plat.db" cls="DataTablesService"
    :template-model="templateModel" @configItem="configColumn">
    <template #area_query>
      <v-layout row align-center>
        <v-flex xs4>
          <v-autocomplete :loading="serviceMethods.getDbs.isBusy" v-model="args.db" hint="选择要查询的数据库" label="数据库"
            persistent-hint :items="serviceMethods.getDbs.data">
            <template #append-outer>
              <v-btn icon flat @click="serviceMethods.getDbs.invokeAsyn()">
                <v-icon>refresh</v-icon>
              </v-btn>
            </template>
          </v-autocomplete>
        </v-flex>
        <v-flex xs4 offset-xs1>
          <v-text-field v-model="args.keyword" counter :autofocus="true" clearable label="关键字"
            append-icon="mdi-circle-edit-outline" @change="query()">
          </v-text-field>
        </v-flex>
      </v-layout>
    </template>

  </gh-table-page>

</template>

<style scoped>

</style>

<script>
  import Table from "./table.ts";
  export default Table;
</script>